import { MappedFormItem } from '@/components/elements/form-map/form-map.component.core';
import { Product } from '@/gql/graphql';
import { IntlShape } from 'react-intl';
import { templateFormMessages } from './template-form.messages';

export const templateMap = (
  intl: IntlShape,
  products: Product[],
  edit?: boolean,
  // context from where the template is being created, the page from where it's being called
  context?: string,
): MappedFormItem[] => {
  const map: MappedFormItem[] = [
    {
      name: 'name',
      label: intl.formatMessage(templateFormMessages.nameInputLabel),
      placeholder: intl.formatMessage(templateFormMessages.nameInputPlaceholder),
      required: true,
      type: 'input',
    },
    {
      name: 'description',
      label: intl.formatMessage(templateFormMessages.descriptionInputLabel),
      placeholder: intl.formatMessage(templateFormMessages.descriptionInputPlaceholder),
      required: true,
      type: 'textarea',
    },
  ];
  if (!edit) {
    map.push({
      name: 'copyAnswersFrom',
      label: intl.formatMessage(templateFormMessages.productSelectLabel),
      placeholder: intl.formatMessage(templateFormMessages.productSelectPlaceholder),
      required: false,
      type: 'select',
      disabled: context === 'product-tailoring' ? true : false,
      options: products.map((product) => ({
        label: product.name,
        value: product.id,
        testId: `copy-answers-from-${product.id}`,
      })),
    });
  }
  return map;
};
